/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Search_Content_PlaceholderInputs */

const cs_blog_filter_search_content_placeholder = /** @type {(inputs: Blog_Filter_Search_Content_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat v těle článku…`)
};

const en_blog_filter_search_content_placeholder = /** @type {(inputs: Blog_Filter_Search_Content_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search article body…`)
};

/**
* | output |
* | --- |
* | "Search article body…" |
*
* @param {Blog_Filter_Search_Content_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_search_content_placeholder = /** @type {((inputs?: Blog_Filter_Search_Content_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Search_Content_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_search_content_placeholder(inputs)
	return cs_blog_filter_search_content_placeholder(inputs)
});